import { active } from "@api/stores/productCategories/active/api";
import { deactive } from "@api/stores/productCategories/deactive/api";
import { stats } from "@api/stores/productCategories/stats/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IProductCategoryDto,
  IProductCategoryGetAllParams,
  IProductCategoryResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IProductCategoryResponse>>,
  IPathBaseParam,
  IPaginationParams & IProductCategoryGetAllParams
>("stores.productCategories");
const postApis = createPostApi<
  IApiResponse<IProductCategoryResponse>,
  IPathBaseParam,
  IProductCategoryDto
>("stores.productCategories");
const getApis = createGetApi<
  IApiResponse<IProductCategoryResponse>,
  IPathByIdParam,
  object
>("stores.productCategories");
const patchApis = createPatchApi<
  IApiResponse<IProductCategoryResponse>,
  IPathByIdParam,
  IProductCategoryDto
>("stores.productCategories");

export const productCategories = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  active,
  deactive,
  stats,
};
